<mat-icon matTooltip="{{ 'GridTable.Filter.FilterModule' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>
<mat-menu #menu="matMenu" class="p-3 moduleMenu" >
    <h2>{{ 'GridTable.Filter.SelectModules' | translate }}</h2>
    <form [formGroup]="moduleFormGroup" (click)="$event.stopPropagation();">
        <div class="row">
            <mat-checkbox matInput formControlName="showOnlyBusinessplan">
                {{ 'Businessplan.NameCredentials' | translate }}
            </mat-checkbox>
        </div>
        <div class="row">
            <mat-checkbox matInput formControlName="showOnlyBusinessModelCanvas">
                {{ 'BusinessModelCanvas.NameCredentials' | translate }}
            </mat-checkbox>
        </div>
    </form>
    <div class="col mt-2" style="display: flex; justify-content: flex-end;">
        <mat-icon matTooltip="{{ 'GridTable.Filter.Cancel' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onCancel()">
            clear
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.ApplyFilter' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onChange()">
            check
        </mat-icon>
    </div>
</mat-menu>
